const UBER = 'Uber';
const INVISAWEAR = 'Invisawear';
const APPLE = 'Apple';
const GOOGLE = 'Google';
const ANI_ALI = 'ANI/ALI';

export { UBER, INVISAWEAR, APPLE, GOOGLE, ANI_ALI };
